"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var _extras = require("../helpers/extras");
var _pricing = require("../helpers/pricing");
var _booking = require("../helpers/booking");
var _booking2 = require("../actions/booking");
var _constants = require("../constants");
var _newComponents = require("../new-components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var DEFAULT_QUANTITY = 1;
var ExtrasProduct = /*#__PURE__*/function (_Component) {
  function ExtrasProduct(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, ExtrasProduct);
    _this = _callSuper(this, ExtrasProduct, [props]);
    _this.state = {
      ordering: false,
      orderingVariant: null,
      removing: false,
      removingVariant: null
    };
    _this.orderProduct = _this.orderProduct.bind(_this);
    _this.removeProduct = _this.removeProduct.bind(_this);
    _this.canRemove = _this.canRemove.bind(_this);
    _this.canOrder = _this.canOrder.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(ExtrasProduct, _Component);
  return (0, _createClass2["default"])(ExtrasProduct, [{
    key: "getText",
    value: function getText(variant) {
      var product = this.props.product.product;
      var text = false;
      if (variant.ordered) {
        text = 'Added';
      } else if (variant.soldOut) {
        text = 'Sold out';
      } else if (product.available) {
        text = "Must be added before ".concat((0, _moment["default"])(product.availableUntil).format('Do MMM'));
      }
      return text;
    }
  }, {
    key: "orderProduct",
    value: function () {
      var _orderProduct = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(variantId, variantPrice, qt) {
        var _this$props, onOrderSuccess, onFailure, booking, noHostSpace, quantity, product, orderResult;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props = this.props, onOrderSuccess = _this$props.onOrderSuccess, onFailure = _this$props.onFailure, booking = _this$props.booking, noHostSpace = _this$props.noHostSpace;
              quantity = qt || DEFAULT_QUANTITY;
              product = this.props.product.product;
              this.setState({
                ordering: true,
                orderingVariant: variantId
              });
              if (!(product.id === _constants.PRODUCTS.TYW_HOSTESS_ID && noHostSpace)) {
                _context.next = 8;
                break;
              }
              onFailure('You are unable to add a Host. Make sure there is room left on your yacht and the event is more than 3 weeks away. If you need help contact Customer Service.');
              this.setState({
                ordering: false,
                orderingVariant: null
              });
              return _context.abrupt("return", true);
            case 8:
              _context.next = 10;
              return this.props.orderExtrasProduct(booking.id, product.type, product.updater, product.id, variantId, quantity);
            case 10:
              orderResult = _context.sent;
              if (orderResult.status === 'success') {
                onOrderSuccess(orderResult.message, variantPrice);
              }
              if (orderResult.status === 'failed') {
                onFailure(orderResult.message);
              }
              this.setState({
                ordering: false,
                orderingVariant: null
              });
              return _context.abrupt("return", true);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function orderProduct(_x, _x2, _x3) {
        return _orderProduct.apply(this, arguments);
      }
      return orderProduct;
    }()
  }, {
    key: "removeProduct",
    value: function () {
      var _removeProduct = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(variantId) {
        var _this$props2, onRemoveSuccess, onFailure, booking, product, removeResult;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this$props2 = this.props, onRemoveSuccess = _this$props2.onRemoveSuccess, onFailure = _this$props2.onFailure, booking = _this$props2.booking;
              product = this.props.product.product;
              this.setState({
                removing: true,
                removingVariant: variantId
              });
              _context2.next = 5;
              return this.props.removeExtrasProduct(booking.id, product.type, product.updater, product.id, variantId);
            case 5:
              removeResult = _context2.sent;
              if (removeResult.status === 'success') {
                onRemoveSuccess(removeResult.message);
              }
              if (removeResult.status === 'failed') {
                onFailure(removeResult.message);
              }
              this.setState({
                removing: false,
                removingVariant: null
              });
              return _context2.abrupt("return", true);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function removeProduct(_x4) {
        return _removeProduct.apply(this, arguments);
      }
      return removeProduct;
    }()
  }, {
    key: "canOrder",
    value: function canOrder(variant) {
      var _this$props3 = this.props,
        product = _this$props3.product,
        userIsBooker = _this$props3.userIsBooker;
      return !variant.ordered && !variant.soldOut && product.product.available && userIsBooker;
    }
  }, {
    key: "isHostessAssigned",
    value: function isHostessAssigned() {
      var booking = this.props.booking;
      if (booking.staffRequests) {
        return booking.staffRequests.some(function (sr) {
          return sr.type === _constants.STAFF.HOSTESS_TYPE && sr.status === _constants.STAFF.ASSIGNED_STATUS;
        });
      }
      return false;
    }
  }, {
    key: "canRemove",
    value: function canRemove(variant) {
      var _this$props4 = this.props,
        product = _this$props4.product,
        order = _this$props4.order,
        userIsBooker = _this$props4.userIsBooker;
      var alreadyPaid = (0, _booking.getPaidAmount)(order);
      // Hostess package can only be removed if not already assigned:
      // Complimentary products can't be removed
      if (product.product.type === _constants.STAFF.HOSTESS_TYPE && this.isHostessAssigned() || product.product.free) {
        return false;
      }
      return variant.ordered && order.status !== _constants.ORDER.PAID_STATUS && alreadyPaid + variant.price <= order.gross && (0, _moment["default"])().isBefore((0, _moment["default"])(product.product.availableUntil)) && userIsBooker;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var booking = this.props.booking;
      var _this$props$product = this.props.product,
        product = _this$props$product.product,
        productVariants = _this$props$product.productVariants;
      var variants = productVariants.map(function (variant) {
        var orderingExtra = _this2.state.ordering && _this2.state.orderingVariant === variant.id;
        var removingExtra = _this2.state.removing && _this2.state.removingVariant === variant.id;
        var imgSrc = variant.contentImage ? variant.contentImage.path : (0, _extras.getDefaultImage)(product.type, _constants.EXTRAS.COPY);
        var readMoreLink = variant.readMoreLink || variant.product.readMoreLink;
        var name = variant.name;
        if (variant.product.id === _constants.PRODUCTS.TYW_HOSTESS_ID) {
          name = 'Host';
        }
        var quantity = variant.addIndividually ? booking.numBoys + booking.numGirls : 1;
        return /*#__PURE__*/_react["default"].createElement(_newComponents.Card, {
          template: "ImageCard",
          imageCardTemplate: "VerticalSplit",
          image: {
            url: imgSrc,
            alt: name
          },
          title: name,
          key: variant.id,
          fullHeight: true
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "flex flex-column justify-between height-100%"
        }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
          className: "d8-u-text-500 d8-u-color-primary"
        }, _this2.getText(variant)), /*#__PURE__*/_react["default"].createElement("div", {
          className: "flex margin-top-sm"
        }, /*#__PURE__*/_react["default"].createElement("h3", {
          className: "d8-u-font-size-base"
        }, (0, _pricing.formatCurrency)(variant.price * quantity / 100, variant.currency)), quantity > 1 && /*#__PURE__*/_react["default"].createElement("p", {
          className: "text-sm margin-left-sm"
        }, "(x", quantity, ")"))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
          className: "d8-u-color-contrast-high text-sm d8-u-text-bold d8-u-ls-sm padding-top-sm"
        }, variant.description || variant.product.description)), /*#__PURE__*/_react["default"].createElement("div", {
          className: "link__wrapper margin-top-md flex grid-gap-md"
        }, _this2.canOrder(variant) && /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "extras-button btn ".concat(orderingExtra ? 'btn--disabled' : 'btn--primary'),
          onClick: function onClick() {
            return _this2.orderProduct(variant.id, variant.price, quantity);
          }
        }, orderingExtra ? 'Ordering...' : 'Add now'), _this2.canRemove(variant) && /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "extras-button btn ".concat(removingExtra ? 'btn--disabled' : 'btn--accent'),
          onClick: function onClick() {
            return _this2.removeProduct(variant.id);
          }
        }, removingExtra ? 'Removing...' : 'Remove'), readMoreLink && /*#__PURE__*/_react["default"].createElement("a", {
          className: "btn flex-row-reverse btn--bare",
          href: readMoreLink,
          target: "_blank"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "flex-shrink-0 margin-left-sm"
        }, /*#__PURE__*/_react["default"].createElement(_newComponents.Svg, {
          name: "arrow-right"
        })), "Read More"))));
      });
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, variants);
    }
  }]);
}(_react.Component);
ExtrasProduct.propTypes = {
  product: _propTypes["default"].object.isRequired,
  booking: _propTypes["default"].object.isRequired,
  order: _propTypes["default"].object.isRequired,
  onOrderSuccess: _propTypes["default"].func.isRequired,
  onRemoveSuccess: _propTypes["default"].func.isRequired,
  onFailure: _propTypes["default"].func.isRequired,
  userIsBooker: _propTypes["default"].bool.isRequired,
  orderExtrasProduct: _propTypes["default"].func.isRequired,
  removeExtrasProduct: _propTypes["default"].func.isRequired,
  noHostSpace: _propTypes["default"].bool
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    orderExtrasProduct: _booking2.orderExtrasProduct,
    removeExtrasProduct: _booking2.removeExtrasProduct
  }, dispatch);
};
var _default = exports["default"] = (0, _reactRedux.connect)(null, mapDispatchToProps)(ExtrasProduct);